import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, CDN_URL, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_EDIT,
	STR_WHATSAPP_MESSAGE,
	STR__NORMAL_SMS,
	STR_MESSAGE_BODY,
	STR_RECEPIENTS,
	STR_ALL,
	STR_SUCCESSFULLY_SENT,
	STR_SEND_FAILED,
	STR_NO_RECORD,
	STR_VIEW_GROUP,
	STR_SCHEDULED_AT,
	STR_MESSAGE_LOGS,
	STR_MESSAGE_LOGS_HELP_TEXT_1,
	STR_VIEW_INTEGRATED_APP,
	STR_VIEW_INTEGRATED_ACCOUNT,
	STR_LEADS,
	STR_CLIENTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdMessage, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdWarning, MdWhatsapp } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import CreateContact from '../views/CreateContact';
import OneContact from '../ones/OneContact';
import OneMessageLog from '../ones/OneMessageLog';

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);
	const [category, setCategory] = useState('all');
	const [pendingLogs, setPendingLogs] = useState([]);
	const [successLogs, setSuccessLogs] = useState([]);
	const [failedLogs, setFailedLogs] = useState([]);
	const [progressingLogs, setProgressingLogs] = useState([]);


	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}



	async function getData() {
		await callApi(
			"get-message-data",
			{
				id,
			}
		).then((response) => {
			if (response.status === 1) {
				setData(response.data)
			}
		})
	}

	function filterLogs() {
		if (data) {
			const _pending = [];
			const _success = [];
			const _failed = [];
			const _progressing = [];

			if (data.messageLogs) {
				for (const _log of data.messageLogs) {
					if (_log.status === 'pending') {
						_pending.push(_log);
					} if (_log.status === 'success') {
						_success.push(_log);
					} if (_log.status === 'failed') {
						_failed.push(_log);
					} if (_log.status === 'in-progress') {
						_progressing.push(_log);
					}
				}
			}

			setPendingLogs(_pending);
			setSuccessLogs(_success);
			setFailedLogs(_failed);
			setProgressingLogs(_progressing);
		}
	}

	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		filterLogs();
	}, [data]);
	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [loading])

	if (ready) {
		return (
			<div
				className="container"
			>

				<div className="row">

					<div className="col-md-12">
						{
							(data.appType) ?
								<span className="badge bg-danger">{data.appType}</span>
								: ""
						}
						<h6
							className="font-semi-bold"
							style={{
								fontSize: "32px"
							}}
						>
							{data.title}
						</h6>



						<span
							className={(data.messageType === 'whatsApp') ? "font-bold badge bg-secondary" : "font-bold badge bg-dark"}
							style={{
								fontSize: "14px"
							}}
						>
							{(data.messageType === 'whatsApp') ? STR_WHATSAPP_MESSAGE[appContext.language] : ""}
							{(data.messageType === 'normalSms') ? STR__NORMAL_SMS[appContext.language] : ""}
						</span>

						{
							(data.isScheduled === 'yes') ?
								<div className="mt-2 mb-2">
									<h6
										style={{
											fontSize: "14px",

										}}
										className="font-semi-bold text-secondary"
									>
										{STR_SCHEDULED_AT[appContext.language]}: {formatDate(data.scheduledAt)}
									</h6>
								</div>
								: ""
						}

						<div className="text-end mt-3">

							<h6
								className="font-regular"
								style={{
									fontSize: "12px"
								}}
							>
								{formatDate(data.dateCreated)}
							</h6>
						</div>

					</div>

					<div className="col-md-12">
						<div className="card">
							<div className="card-body">

								{
									(data.appType && data.appType === 'mauzocrm') ?
										<div className="mt-2 mb-4">
											<h6
												className="card-title"
											>
												{STR_RECEPIENTS[appContext.language]}
											</h6>

											<h6
												className="font-bold text-muted"
												style={{
													fontSize: "16px"
												}}
											>
												{data.contactGroupId === 'leads' ? STR_LEADS[appContext.language] : ""}
												{data.contactGroupId === 'clients' ? STR_CLIENTS[appContext.language] : ""}
											</h6>
										</div>
										: ""
								}

								<h6
									className="card-title"
								>
									{STR_MESSAGE_BODY[appContext.language]}
								</h6>
								{
									(data.messageMediaUrl) ?
										<img
											src={CDN_URL + data.messageMediaUrl}
											style={{
												width: "100%",
												height: "auto",
											}}
										/>
										: ""
								}

								<div className="">
									<pre
										style={{
											fontSize: "18px"
										}}
									>
										{data.body}
									</pre>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-12">
						<h6
							className="font-semi-bold mt-4"
							style={{
								fontSize: "18px",

							}}
						>
							{STR_MESSAGE_LOGS[appContext.language]}
						</h6>

						<div className="text-end mb-4">
							{
								(data.appType && data.accountId) ?
									<>

										{
											(data.appType === 'mauzocrm') ?
												<button
													className="btn btn-sm btn-dark btn-rounded"
													onClick={() => {
														appContext.navTo({
															item: 'integrated-apps',
															subItem: 'mauzocrm',
															extraItem: 'business',
															moreItem: data.accountId,
														})
													}}
												>
													{STR_VIEW_INTEGRATED_ACCOUNT[appContext.language]}
												</button>
												: ""
										}

									</>
									:
									<button
										className="btn btn-sm btn-dark btn-rounded"
										onClick={() => {
											appContext.navTo({
												item: 'side-view',
												subItem: 'contact-group-options',
												extraItem: data.contactGroupId,
											})
										}}
									>
										{STR_VIEW_GROUP[appContext.language]}
									</button>
							}
						</div>

						{
							(data.messageLogs && data.messageLogs.length > 0) ?
								<div className="card">
									<div className="card-body">

										<div className="row">
											<div className="col-md-6 mb-2">
												<div
													className=""
													style={{
														borderRadius: "10px",
														padding: "10px",
														border: "1px solid var(--primaryColor)"
													}}
												>

													<h6
														style={{
															fontSize: "32px"
														}}
													>
														{formatMoney(data.messageLogs?.length)}
													</h6>
													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														{STR_ALL[appContext.language]}
													</h6>
												</div>
											</div>

											<div className="col-md-6 mb-2">
												<div
													className=""
													style={{
														borderRadius: "10px",
														padding: "10px",
														border: "1px solid var(--primaryColor)"
													}}
												>

													<h6
														style={{
															fontSize: "32px"
														}}
													>
														{formatMoney(successLogs?.length)}
													</h6>
													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Success
													</h6>
												</div>
											</div>

											<div className="col-md-6 mb-2">
												<div
													className=""
													style={{
														borderRadius: "10px",
														padding: "10px",
														border: "1px solid var(--primaryColor)"
													}}
												>

													<h6
														style={{
															fontSize: "32px"
														}}
													>
														{formatMoney(pendingLogs?.length)}
													</h6>
													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Pending
													</h6>
												</div>
											</div>

											<div className="col-md-6 mb-2">
												<div
													className=""
													style={{
														borderRadius: "10px",
														padding: "10px",
														border: "1px solid var(--primaryColor)"
													}}
												>

													<h6
														style={{
															fontSize: "32px"
														}}
													>
														{formatMoney(failedLogs?.length)}
													</h6>
													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Failed
													</h6>
												</div>
											</div>

											<div className="col-md-6 mb-2">
												<div
													className=""
													style={{
														borderRadius: "10px",
														padding: "10px",
														border: "1px solid var(--primaryColor)"
													}}
												>

													<h6
														style={{
															fontSize: "32px"
														}}
													>
														{formatMoney(progressingLogs?.length)}
													</h6>
													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														In Progress
													</h6>
												</div>
											</div>

										</div>

										<hr />

										<div className="mt-2 mb-2">
											<select
												className="form-control"
												value={category}
												onChange={(e) => setCategory(e.target.value)}
											>
												<option value='all'>{STR_ALL[appContext.language]}</option>
												<option value='pending'>Pending</option>
												<option value='success'>Success</option>
												<option value='failed'>Failed</option>
												<option value='in-progress'>In Progress</option>
											</select>
										</div>

										{
											(category === 'all') ?
												(data.messageLogs && data.messageLogs.length > 0) ?
													data.messageLogs.map((item, i) => {
														return (
															<OneMessageLog data={item} key={i} />
														)
													})
													:
													<h6
													>
														{STR_NO_RECORD[appContext.language]}
													</h6>
												: ""
										}

										{
											(category === 'pending') ?
												(pendingLogs && pendingLogs.length > 0) ?
													pendingLogs.map((item, i) => {
														return (
															<OneMessageLog data={item} key={i} />
														)
													})
													:
													<h6
													>
														{STR_NO_RECORD[appContext.language]}
													</h6>
												: ""
										}

										{
											(category === 'success') ?
												(successLogs && successLogs.length > 0) ?
													successLogs.map((item, i) => {
														return (
															<OneMessageLog data={item} key={i} />
														)
													})
													:
													<h6
													>
														{STR_NO_RECORD[appContext.language]}
													</h6>
												: ""
										}

										{
											(category === 'failed') ?
												(failedLogs && failedLogs.length > 0) ?
													failedLogs.map((item, i) => {
														return (
															<OneMessageLog data={item} key={i} />
														)
													})
													:
													<h6
													>
														{STR_NO_RECORD[appContext.language]}
													</h6>
												: ""
										}

										{
											(category === 'in-progress') ?
												(progressingLogs && progressingLogs.length > 0) ?
													progressingLogs.map((item, i) => {
														return (
															<OneMessageLog data={item} key={i} />
														)
													})
													:
													<h6
													>
														{STR_NO_RECORD[appContext.language]}
													</h6>
												: ""
										}

									</div>
								</div>
								:
								<div className="card">
									<div className="card-body">

										<h3
											className="text-center"
											style={{
												fontSize: "18px"
											}}
										>
											<MdWarning size={52} />
											<br />
											{STR_MESSAGE_LOGS_HELP_TEXT_1[appContext.language]}
										</h3>

									</div>
								</div>

						}
					</div>

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}